<app-icon-button [icon]="closeIcon" (click)="close()" [border]="false"></app-icon-button>
<div class="wrapper">
  <div class="inner-wrapper">
    <div class="basket">
      <header>
        <h2>Tilføjet til kurven</h2>
      </header>
      <div class="basket-items">
        <app-meny-basket-item [product]="data.product" [quantity]="quantity | async" (deleteCallback)="close()"></app-meny-basket-item>
        @for (addition of productAdditions | async; track addition.product.id) {
          <app-meny-basket-item [product]="addition.product" [quantity]="addition.quantity"></app-meny-basket-item>
        }
      </div>

      @let price = getPrice(productLine | async, productAdditions | async);
      <div class="total-price">
        <b
          >Total: {{ price | number: '.2-2' : locale }}
          {{ currency | displayCurrency }}
        </b>
        <span id="tax">
          heraf moms {{ price * 0.2 | number: '.2-2' : locale }}
          {{ currency | displayCurrency }}
        </span>
      </div>
      <div class="buttons">
        <app-text-button class="buy-more" color="accent" (click)="close()">{{ buyMoreButtonText }}</app-text-button>
        <app-text-button (click)="redirectAndClose(basketOverviewUrl)">{{ basketButtonText }}</app-text-button>
      </div>
    </div>

    @if (displayedProductAddition?.products.length) {
      <div class="additional-products">
        <h2>{{ displayedProductAddition.name }}</h2>
        <div>
          @for (product of displayedProductAddition?.products; track product.id) {
            <app-product-card [product]="product"></app-product-card>
          }
        </div>
      </div>
    }
  </div>
</div>
